import { request } from "./client";
import type { Placement, PlacementCreateCommand, PlacementRevisionCommand } from "./types";

const base = "/admin/v1/placements";

export const placements = {
  list: () => request<Placement[]>(base),
  get: (id: string) => request<Placement>(`${base}/${id}`),
  create: (command: PlacementCreateCommand) =>
    request<Placement>(base, { method: "POST", body: command, csrf: true }),
  revise: (id: string, command: PlacementRevisionCommand) =>
    request<Placement>(`${base}/${id}`, { method: "PUT", body: command, csrf: true }),
  archive: (id: string) =>
    request<Placement>(`${base}/${id}`, { method: "DELETE", csrf: true }),
};
